module.exports = __webpack_public_path__ + "2021525:777057f5211ffb5bd912/img/v2_Slide_16_9-3-2x.14e0c51.jpg";